<template>
  <div class="footer">
    <div class="title">参与商家</div>
    <div class="content">
      <div class="item" v-for="item in list" :key="item.id">
        <div class="text">
          <span>{{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    goodsInfo: Object,
  },
  data() {
    return {
      list: [
        "湖州广成盈达新能源汽车有限公司",
        "湖州湖旗汽车有限公司",
        "湖州零点汽车有限公司",
        "湖州兴瑞雷克萨斯汽车销售服务有限公司",
        "湖州之田汽车销售服务有限公司",
        "湖州盛通汽车销售有限公司",
        "湖州弘通汽车销售服务有限公司",
        "湖州风神汽车销售服务有限公司",
        "湖州领耀汽车销售服务有限公司",
        "湖州湖马汽车有限公司",
        "湖州明枫汽车销售服务有限公司",
        "湖州万林汽车有限公司",
        "湖州合润汽车有限公司",
        "湖州广瑞汽车有限公司",
        "湖州广成湖迪新能源汽车有限公司",
        "湖州腾势汽车销售有限公司",
        "湖州市利驰汽车销售服务有限公司",
        "湖州瑞杰汽车销售服务有限责任公司",
        "湖州永达路宝汽车销售服务有限公司",
        "湖州中北汽车销售服务有限公司",
        "湖州长铃汽车销售服务有限公司",
        "湖州宝睿汽车销售服务有限公司",
        "湖州国戎汽车销售服务有限公司",
        "湖州永达奥诚汽车销售有限公司",
        "湖州永达汽车销售服务有限公司",
        "湖州宏安汽车销售有限公司",
        "湖州金丰丰田汽车销售服务有限公司",
        "湖州元盛汽车有限公司",
        "湖州长运汽车销售服务有限公司",
        "湖州之星汽车有限公司",
      ],
    };
  },

  methods: {
    onPhone() {
      SmartCity.makeCall({
        tel: "15757297571",
      });
    },
  },
};
</script>

<style scoped lang="less">
.footer {
  background: #0f6ad3;

  padding: 10px;

  .title {
    font-size: 18px;
    color: #fff;
    text-align: center;
    padding: 10px;
  }

  .content {
    background: #fff;
    border-radius: 10px;
    // margin: 20px;
    padding: 10px;
    .item {
      display: flex;
      margin-bottom: 10px;

      .icon {
        width: 26px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        font-size: 12px;
        color: #fff;
        border-radius: 50%;
        background: @main;
        margin-right: 10px;
      }
      .text {
        flex: 1;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
</style>
